import React, { FC } from 'react';
import ConfirmDialog from '@components/Dialogs/ConfirmDialog';
import { Box, Typography } from '@mui/material';

export type NodeActionConfirmItem = { id: string; name: string };

type Props = {
  open: boolean;
  title: string;
  text: string;
  toChange: NodeActionConfirmItem[];
  toChangeTitle: string;
  skipped: NodeActionConfirmItem[];
  toSkipTitle: string;
  confirmName: string;
  onBack: () => void;
  onConfirm: () => void;
};

export const NodeActionConfirmModal: FC<Props> = ({
  open,
  title,
  text,
  toChange,
  toChangeTitle,
  skipped,
  toSkipTitle,
  confirmName,
  onBack,
  onConfirm,
}) => (
  <ConfirmDialog
    open={open}
    onClose={onBack}
    onBack={onBack}
    onConfirm={onConfirm}
    disabled={toChange.length === 0}
    title={title}
    text={text}
    confirmName={confirmName}
    backName="Cancel"
  >
    {toChange.length > 0 && (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="h5" color="grey.900">
          {toChangeTitle}
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 4, color: 'grey.900' }}>
          {toChange.map((node) => (
            <li key={node.id}>{node.name}</li>
          ))}
        </Box>
      </Box>
    )}

    {skipped.length > 0 && (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="h5" color="grey.900">
          {toSkipTitle}
        </Typography>
        <Box component="ul" sx={{ m: 0, pl: 4, color: 'grey.900' }}>
          {skipped.map((node) => (
            <li key={node.id}>{node.name}</li>
          ))}
        </Box>
      </Box>
    )}
  </ConfirmDialog>
);
